import { Pipe, PipeTransform } from '@angular/core';
import { StatistikTilafgangKunde } from './StatistikTilafgangKunde';

@Pipe({
    name: 'StatistikTilafgangGrundPipe',
    standalone: false
})
export class StatistikTilafgangGrundPipe implements PipeTransform {
    transform(array: StatistikTilafgangKunde[]): number[] {

        let numberList: number[] = [0, 0, 0, 0, 0];
        if (!array || array.length < 1) {
            return numberList;
        }

        const price = array.filter(x => x.kundeophortKode === 0).length;
        const chemistry = array.filter(x => x.kundeophortKode === 1).length;
        const bankruptcy = array.filter(x => x.kundeophortKode === 2).length;
        const saledeath = array.filter(x => x.kundeophortKode === 3).length;
        const other = array.filter(x => x.kundeophortKode === 4).length;

        numberList = [price, chemistry, bankruptcy, saledeath, other];
        return numberList;
    }
}
